import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPassword = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M15.523 44.227c2.148 2.148 5.605 2.148 12.519 2.148l9.166-.002c5.71-.016 8.737-.197 10.686-2.146 2.148-2.148 2.148-5.605 2.148-12.519s0-10.37-2.148-12.518c-1.95-1.95-4.976-2.13-10.686-2.147l-9.166-.001c-6.914 0-10.371 0-12.52 2.147-2.147 2.148-2.147 5.605-2.147 12.52 0 6.913 0 10.37 2.148 12.518"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.667 31.708c0-3.495-.003-5.979-.256-7.863-.248-1.844-.714-2.907-1.49-3.683-.706-.706-1.647-1.152-3.19-1.414-1.584-.269-3.654-.321-6.526-.33l-9.163-.001c-3.496 0-5.98.002-7.864.256-1.844.248-2.907.713-3.682 1.49-.776.775-1.242 1.838-1.49 3.682-.253 1.884-.256 4.368-.256 7.863s.003 5.98.256 7.864c.248 1.844.714 2.907 1.49 3.682.776.776 1.838 1.242 3.682 1.49 1.884.253 4.368.256 7.864.256l9.163-.002 2.009-.018c1.868-.03 3.33-.11 4.517-.311 1.543-.262 2.484-.709 3.19-1.415.776-.775 1.242-1.838 1.49-3.682.253-1.884.256-4.368.256-7.864m2.75 0c0 3.418.002 6.12-.281 8.23-.29 2.15-.899 3.889-2.27 5.26-1.244 1.244-2.79 1.863-4.675 2.183-1.845.313-4.143.359-6.98.367l-9.17.002c-3.417 0-6.12.003-8.23-.281-2.149-.29-3.888-.898-5.26-2.27s-1.98-3.111-2.27-5.26c-.284-2.11-.281-4.813-.281-8.23 0-3.419-.003-6.121.281-8.231.29-2.15.898-3.888 2.27-5.26s3.111-1.981 5.26-2.27c2.11-.284 4.813-.281 8.23-.281l9.17.002c2.837.008 5.135.054 6.98.366 1.884.32 3.431.94 4.674 2.183 1.372 1.372 1.982 3.11 2.27 5.26.284 2.11.282 4.812.282 8.23"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M26.208 31.708a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0m7.334 0a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0M35.833 50.042V13.375a1.375 1.375 0 1 1 2.75 0v36.667a1.375 1.375 0 1 1-2.75 0"
      />
    </svg>
  );
};
export default SvgPassword;
